<template>
    <div>

        <!-- Intervenants -->
        <h1 class="label">Intervenants CEN
            {{ ProjectDayCost === null ? `au coût jour` : `au forfait prestation (${ProjectDayCost} €)` }}</h1>

        <div class="level">
            <b-button class="is-primary" @click="isAddModalActive = true">
                Ajouter un intervenant
            </b-button>
            <b-button class="is-warning" @click="deleteAllTD">
                Supprimer tous les intervenants
            </b-button>
        </div>

        <b-table :data="td">
            <template>

                <b-table-column field="salarie" label="Personnel" width="300" sortable
                                v-slot="props">
                    <b-icon icon="user"></b-icon>
                    {{ props.row.salarie }} <br>
                    <em>{{ getPoste(props.row.salarie) }}</em>
                </b-table-column>

                <b-table-column field="days" label="Durée (j)" sortable v-slot="props">
                    {{ props.row.days }}
                </b-table-column>

                <b-table-column field="customDayCost" label="Coût jour spécifique" sortable v-slot="props">
                    {{ props.row.customcost ? props.row.customcost + " €" : "-" }}
                </b-table-column>

                <b-table-column field="days" label="Frais de personnel" sortable v-slot="props">
                    {{ subCost(props.row.days, props.row.salarie, props.row.customcost) }}
                </b-table-column>

                <b-table-column field="comment" label="Tâche" v-slot="props">
                    {{ props.row.comment || '_____________' }}
                </b-table-column>

                <b-table-column label="Editer" v-slot="props">
                    <b-button
                        type="is-warning"
                        icon-left="pen"
                        @click="openEditModal(props.row)"
                    ></b-button>
                </b-table-column>

                <b-table-column label="Supprimer" v-slot="props">
                    <b-button
                        type="is-danger"
                        icon-left="trash"
                        @click="deleteTodo(props.row)"
                    ></b-button>
                </b-table-column>

                <!-- Footer -->
                <template slot="footer">
                    <th style="width:40px">
                        <div class="th-wrap is-numeric"> Nb. d'intervenants : {{ td.length }}</div>
                    </th>
                    <th>
                        <div class="th-wrap"> Nombre de jours : {{ totalDays }}</div>
                    </th>
                    <th></th>
                    <th>
                        <div class="th-wrap"> Total : {{ totalCost }} €</div>
                    </th>
                </template>

            </template>
        </b-table>

        <b-modal :active.sync="isEditModalActive" has-modal-card>
            <todo-edit-modal
                :uuid="this.selectedLine.uuid"
                :salarie=this.selectedLine.salarie
                :days=this.selectedLine.days
                :customcost=this.selectedLine.customcost
                :comment=this.selectedLine.comment
                :start=this.selectedLine.start
                :end=this.selectedLine.end
                :salariesFree="salariesFree"
                @edit-todo="onEditTodo"
            ></todo-edit-modal>
        </b-modal>

        <b-modal :active.sync="isAddModalActive" has-modal-card>
            <todo-add-modal
                @add-todo="onAddTodo"
                :salariesFree="salariesFree"
            ></todo-add-modal>
        </b-modal>
    </div>

</template>

<script>
import TodoEditModal from "@/components/TodoEditModal";
import TodoAddModal from "@/components/TodoAddModal";
import {v4 as uuidv4} from 'uuid';

export default {
    name: "Salaries",
    props: ['ProjectDayCost'],
    components: {TodoEditModal, TodoAddModal},
    mounted() {
        if (localStorage.getItem("td")) {
            this.td = JSON.parse(localStorage.getItem("td"));
        } else {
            this.td = [];
        }
        // Load ref
        this.$axios.get('ref/salaries')
            .then(function (response) {
                this.refSalariesTemp = response.data.salaries.salaries;
            }.bind(this))
            .catch(error => console.log(error));
        // Load conf
        this.$axios.get('conf', {})
            .then((conf) => {
                this.coutderevient = conf.data.conf.conf.coutderevient
                this.servicesSupport = conf.data.conf.conf.servicesSupport
            });
    },
    computed: {
        totalDays() {
            return this.td.reduce((acc, cur) => acc + Number(cur.days), 0);
        },
        totalCost() {
            let daysWithoutSupport = 0;
            let sum = 0;
            let marge = 0;
            let p = JSON.parse(localStorage.getItem("project"));
            // If forfait jour Prestation, deal with stagiaire too
            if (this.ProjectDayCost) {
                // sum = this.totalDays * this.ProjectDayCost;
                this.td.forEach(e => {
                    const v = this.refSalariesTemp.find(s => s.name === e.salarie);
                    // Stagiaires
                    if (v !== undefined && v.type === 'stagiaire') {
                        sum += e.days * v.daycost;
                        // Pas de marge sur les stagiaires
                    }
                    // if custom custom cost is set
                    else if (e.customcost > 0) {
                        sum += e.days * e.customcost;
                        marge += (e.days * e.customcost) - (e.days * this.coutderevient);
                    }
                    // Default
                    else {
                        sum += e.days * this.ProjectDayCost;
                        marge += (e.days * this.ProjectDayCost) - (e.days * this.coutderevient);
                    }
                })

                /*
                  for (const e of this.td) {
                    let v = this.refSalariesTemp.filter(s => s.name === e.salarie);
                    let w = v.map(a => a.daycost);
                    marge = v.length ? (marge + ((this.ProjectDayCost * e.days) - (w * e.days))) : 0;
                  }
                 */
            } else if (p.type === 'Charge uniquement ⚠️') { // If only charge
                sum = 0;
            } else { // Else real cost Subvention
                this.td.forEach(e => {
                    const v = this.refSalariesTemp.filter(s => s.name === e.salarie);
                    // Days without support
                    let serv = v.length ? v[0].service : null;
                    daysWithoutSupport += this.servicesSupport.includes(serv) ? 0 : e.days
                    // if custom custom cost is set
                    if (e.customcost > 0) {
                        sum += e.days * e.customcost;
                        marge = 0; // TODO : vérif que pas de marge si customcost sur subvention
                    }
                    // Default
                    else {
                        sum = v.length ? sum + v[0].daycost * e.days : 0;
                        marge = 0;
                    }
                })
            }
            // Send sum to tags
            this.$emit('updateProjectSalariesCost', sum);
            this.$emit('updateProjectSalariesMarge', marge);
            this.$emit('updateProjectDaysWithoutSupport', daysWithoutSupport);
            return sum
        },
        salariesFree() {
            // Select a salarie only once
            // return this.refSalariesTemp.filter(md => this.td.every(fd => fd.salarie !== md.name));
            // Select a salarie multiple time
            // return this.refSalariesTemp;
            // Update free days
            let clone = JSON.parse(JSON.stringify(this.refSalariesTemp));
            this.td.forEach(fd => {
                clone.forEach(rs => {
                    if (fd.salarie === rs.name) {
                        rs.days += fd.days
                    }
                })
            })
            return clone;
        },
    },
    methods: {
        getPoste(s) {
            const p = this.refSalariesTemp.filter(md => s === md.name)
            return p.map(a => a.fonction)[0];
        },
        subCost(days, name, customcost) {
            if (customcost > 0) {
                return `${days * customcost} € ( ${days} * ${customcost} )`;
            } else if (this.ProjectDayCost !== null) {
                // Test if salaries or stagiaire
                let dc = this.refSalariesTemp.find(s => s.name === name);
                if (dc !== undefined && dc.type === "stagiaire") {
                    return `${dc.daycost * days} € ( ${days} * ${dc.daycost} )`;
                } else {
                    return `${days * this.ProjectDayCost} € ( ${days} * ${this.ProjectDayCost} )`;
                }
            } else {
                let dc = this.refSalariesTemp.filter(s => s.name === name);
                // TODO to fix
                return dc.length ? `${days * dc[0].daycost} € ( ${days} * ${dc[0].daycost} )` : 0;
            }
        },
        openEditModal(line) {
            this.selectedLine = line;
            this.isEditModalActive = true;
        },
        onAddTodo(item) {
            // Add the item to the array
            this.td.push({
                uuid: uuidv4(),
                salarie: item.salarie,
                days: item.days,
                customcost: parseFloat(item.customcost),
                comment: item.comment,
                start: item.start,
                end: item.end,
            });
            // save the updated array in localstorage
            this.saveLocalStorageTD();
            this.isAddModalActive = false;
        },
        onEditTodo(item) {
            const todo = this.findTodo(item);
            // Apply the updated values
            todo.days = item.days;
            todo.comment = item.comment;
            todo.customcost = item.customcost;
            todo.start = item.start;
            todo.end = item.end;
            // save the updated array in localstorage
            this.saveLocalStorageTD();
            // close the modal
            this.isEditModalActive = false;
        },
        deleteTodo(item) {
            this.$buefy.dialog.confirm({
                title: `Supprimer la ligne`,
                confirmText: "Supprimer la ligne",
                type: "is-danger",
                hasIcon: true,
                message: `Etes-vous sûr de supprimer cette ligne ? Cette action ne pourra être annulée.`,
                onConfirm: () => {
                    // find in the array and remove
                    const index = this.td.indexOf(item);
                    this.td.splice(index, 1);
                    // save the updated array in localstorage
                    this.saveLocalStorageTD();
                }
            });
        },
        deleteAllTD() {
            this.$buefy.dialog.confirm({
                title: `Supprimer tous les salariés`,
                confirmText: "Oui, je confirme",
                type: "is-danger",
                hasIcon: true,
                message: `Etes-vous sûr de vouloir supprimer l'ensemble des salariés ? Cette action ne pourra pas être annulée`,
                onConfirm: () => {
                    this.td = [];
                    // save the updated array in localstorage
                    this.saveLocalStorageTD();
                }
            });
        },
        findTodo(item) {
            return this.td.find(todo => todo.uuid === item.uuid);
        },
        saveLocalStorageTD() {
            localStorage.setItem("td", JSON.stringify(this.td));
            this.td = JSON.parse(localStorage.getItem("td"));
        }
    },
    data() {
        return {
            td: [],
            refSalariesTemp: [],
            isEditModalActive: false,
            selectedLine: {},
            isAddModalActive: false,
            coutderevient: null,
            servicesSupport: [],
        }
    },
}
</script>

<style scoped>

</style>
